import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import Anchor from "../Anchor";
import classNames from "classnames";
import getClassNameFactory from "../../utilities/classNames";

var Button = /*#__PURE__*/function (_React$Component) {
  _inherits(Button, _React$Component);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getClassName", getClassNameFactory(Button.displayName));

    return _this;
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          block = _this$props.block,
          children = _this$props.children,
          color = _this$props.color,
          contentLocation = _this$props.contentLocation,
          disabled = _this$props.disabled,
          href = _this$props.href,
          icon = _this$props.icon,
          iconOnly = _this$props.iconOnly,
          kind = _this$props.kind,
          loading = _this$props.loading,
          modalLabel = _this$props.modalLabel,
          newWindow = _this$props.newWindow,
          onClick = _this$props.onClick,
          shape = _this$props.shape,
          size = _this$props.size,
          innerRef = _this$props.innerRef,
          title = _this$props.title,
          id = _this$props.id,
          rest = _objectWithoutProperties(_this$props, ["active", "block", "children", "color", "contentLocation", "disabled", "href", "icon", "iconOnly", "kind", "loading", "modalLabel", "newWindow", "onClick", "shape", "size", "innerRef", "title", "id"]);

      var bodyProps = {
        className: this.getClassName({
          descendantName: "body",
          utilities: Boolean(icon) && iconOnly && "hiddenVisually"
        })
      };
      var iconProps = {
        className: this.getClassName({
          descendantName: "icon"
        })
      };
      return /*#__PURE__*/React.createElement(Anchor, _extends({
        href: href,
        id: id,
        className: this.getClassName({
          modifiers: classNames(color, block ? "block" : null, icon && iconOnly ? "iconOnly" : null, size, shape),
          states: classNames({
            active: active,
            disabled: disabled,
            loading: loading
          })
        }),
        contentLocation: contentLocation,
        disabled: disabled,
        modalLabel: modalLabel,
        newWindow: newWindow,
        onClick: onClick,
        kind: kind,
        innerRef: innerRef,
        title: title
      }, rest), /*#__PURE__*/React.createElement("span", bodyProps, children), icon && /*#__PURE__*/React.createElement("span", iconProps, icon));
    }
  }]);

  return Button;
}(React.Component);

_defineProperty(Button, "displayName", "Button");

export default Button;